import { Button, Col, Form, Input, Row, Select } from "antd";
import { ColumnsType } from "antd/lib/table";
import React, { useContext, useState } from "react";
import { ButtonPanel } from "../../../../component/button-panel/button_panel";
import { FormSubtitle } from "../../../commodity/view/form_subtitle";
import styles from "../../style/inventory_goods_formbasic.module.scss";

import img_del from "../../../../assets/images/shanchu.png";
import { useBoolean } from "ahooks";
import { ChooseGoods } from "../../../../component/choose-goods";
import { Table } from "../../../../component/table";
import { ChooseShop } from "../../../../component/choose-shop";
import { TableExpand } from "../../../../component/table-expand";
import { CostFormStore } from "../../store/cost/cost_form_store";
import { costFormAction } from "../../action/cost/cost_form_action";
import { autoRem } from "../../../../global.style";
import { NumberTool } from "../../../../tool/numberTool";

const { Option } = Select;

export function DataTable({ dataList, disabled }) {
  const { dispatch } = useContext(CostFormStore);
  const [current, setCurrent] = useState(1);
  const [pageSize, setSize] = useState(10);
  const action = costFormAction;

  const columns: ColumnsType = [
    {
      title: "操作",
      dataIndex: "serial",
      key: "1",
      align: "center",
      width: 100,
      render: (v, r, i) => (
        <div>
          <img
            src={img_del}
            style={{ width: 20 }}
            onClick={() => {
              if (disabled) return;
              action.delTableItem(dispatch, i);
            }}
          />
        </div>
      ),
    },
    {
      title: "批次号",
      dataIndex: "storageBatchNumber",
      key: "0",
      align: "center",
      width: 190
    },
    {
      title: "商品编码",
      dataIndex: "goodsCode",
      key: "2",
      align: "center",      
      width: 160
    },
    {
      title: "商品名称",
      dataIndex: "goodsName",
      key: "3",
      align: "center",
      width: 120
    },
    {
      title: "库存单位",
      dataIndex: "unitName",
      key: "4",
      align: "center",
      width: 80
    },
    {
      title: "库存数量",
      dataIndex: "number",
      key: "9",
      align: "center",
      width: 120
    },
    // {
    //   title: "商品规格",
    //   dataIndex: "inStockUnit",
    //   key: "4",
    //   align: "center",
    //   render: (e, r, i) => {
    //     return <div>****</div>;
    //   },
    // },
    {
      title: "原库存价",
      dataIndex: "beforePrice",
      key: "8",
      align: "center",
      width: 120
      //   render: (e, r, i) => {
      //     return <div>****</div>;
      //   },
    },
    {
      title: "新库存价",
      dataIndex: "latestPrice",
      key: "9",
      align: "center",
      width: 120,
      render: (e, r: any, i) => {
        console.log(e);
        return (
          <Input
            disabled={disabled}
            type="number"
            value={e}
            onChange={(e) => {
              dispatch({
                type: "ChangeTableItem",
                payload: {
                  index: i + (current - 1) * pageSize,
                  key: "latestPrice",
                  value: parseFloat(e.target.value),
                },
              });
            }}
          />
        );
      },
      //   render: (e, r, i) => {
      //     return <div>****</div>;
      //   },
    },
    {
      title: "变更差额",
      dataIndex: "diffPrice",
      key: "9",
      align: "center",
      width: 120
      // render: (e, r, i) => {
      //   return <div>****</div>;
      // },
    },
  ];

  return (
    <Table
      scroll={{ y: 275 }}
      dataSource={dataList}
      columns={columns}
      onChange={(pagination) => {
        setCurrent(pagination.current);
        setSize(pagination.pageSize);
      }}
      // expandable={{
      //   expandedRowRender: (record) => {
      //     return record.goodsSpecifications.map((item, index) => {
      //       return (
      //         <GetSpecifications
      //           disabled={disabled}
      //           index={index}
      //           specifications={item}
      //           unitName={record.unitName}
      //         />
      //       );
      //     });
      //   },
      //   rowExpandable: (record) => record.name !== "Not Expandable",
      // }}
    />
  );
}

function GetSpecifications({ specifications, unitName, disabled, index }) {
  const { state, dispatch } = useContext(CostFormStore);
  return (
    <div className={styles.specifications}>
      <div className={styles.info}>
        <span>{specifications.unitContent}</span>
        <span>{unitName}</span>
      </div>
      <div className={styles.input} style={{ width: 80 }}>
        <span>￥{NumberTool.toAmount(specifications.inventoryPrice || 0)}</span>
      </div>
      <div className={styles.input} style={{ width: 100 }}>
        <Input
          disabled={disabled}
          type="number"
          value={specifications.afterPrice}
          onChange={(e) => {
            specifications.afterPrice = Math.abs(
              parseFloat(e.currentTarget.value)
            );
            dispatch({
              type: "ChangeTableItem",
              payload: {
                index,
                key: "latestPrice",
                value: specifications.afterPrice,
              },
            });
          }}
        />
      </div>
      <div className={styles.input} style={{ width: 80 }}>
        <span>
          ￥
          {NumberTool.toAmount(
            specifications.afterPrice - specifications.inventoryPrice || 0
          )}
        </span>
      </div>
    </div>
  );
}

export function CostFormBasic({ disabled, updateFormField }) {
  const [shopState, shopFunc] = useBoolean(false);
  const [goodsState, goodsFunc] = useBoolean(false);

  const { state, dispatch } = useContext(CostFormStore);
  const { formData } = state;

  const action = costFormAction;

  const count = (key) => {
    return state.tableList.map((v) => v[key]).reduce((p, c) => p + c, 0);
  };
  let height = document.body.clientHeight - 188 + 26;
  return (
    <div className={styles.root} style={{ height: height + "px" }}>
      <div className={styles.content}>
        <FormSubtitle>基础信息</FormSubtitle>

        <div
          style={{
            margin: "" + autoRem(1.9375) + " " + autoRem(1.25) + " 0 0",
          }}
        >
          <Row gutter={16} style={{ marginTop: 0 }}>
            <Col span={6}>
              <Form.Item name="" label="制单人" labelCol={{ span: 8 }}>
                <span>{formData.userName}</span>
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item label="制单时间" labelCol={{ span: 8 }}>
                <span style={{ display: "block", minWidth: 200 }}>
                  {formData.date}
                </span>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={6}>
              <Form.Item
                label="门店"
                name="shopName"
                labelCol={{ span: 8 }}
                rules={[
                  {
                    required: true,
                    message: "请选择门店",
                    validator: (
                      rule,
                      value,
                      callback: (error?: string) => void
                    ) => {
                      if (!formData.shop?.shopName) {
                        callback("请选择门店");
                      } else {
                        callback();
                      }
                    },
                  },
                ]}
              >
                {formData.shop.shopName ? "" : ""}
                <Input
                  disabled={disabled}
                  value={formData.shop && formData.shop.shopName}
                  autoComplete="off"
                  placeholder="请选择"
                  onClick={() => shopFunc.setTrue()}
                />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                label="理由"
                name="reasonId"
                labelCol={{ span: 8 }}
                rules={[
                  {
                    required: true,
                    message: "请选择理由",
                    validator: (
                      rule,
                      value,
                      callback: (error?: string) => void
                    ) => {
                      if (!formData.reasonId) {
                        callback("请选择理由");
                      } else {
                        callback();
                      }
                    },
                  },
                ]}
              >
                {formData.reasonId ? "" : ""}
                <Select
                  disabled={disabled}
                  value={formData.reasonId}
                  onChange={(v) => {
                    action.setFormData({ dispatch, key: "reasonId", value: v });
                    updateFormField("reasonId");
                  }}
                >
                  <Option value={1}>日常变更</Option>
                  <Option value={2}>其他变更</Option>
                </Select>
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item label="备注" labelCol={{ span: 8 }}>
                <Input
                  maxLength={200}
                  disabled={disabled}
                  value={formData.remark}
                  autoComplete="off"
                  onChange={(v) =>
                    action.setFormData({
                      dispatch,
                      key: "remark",
                      value: v.target.value,
                    })
                  }
                />
              </Form.Item>
            </Col>
          </Row>
        </div>

        <div style={{ marginTop: -20 }}>
          <FormSubtitle>商品信息</FormSubtitle>
        </div>

        <div
          style={{
            margin: "" + autoRem(1.9375) + " " + autoRem(1.25) + " 0 0",
          }}
        >
          {/* <Row gutter={16} style={{ marginTop: 10 }}>
            <Col span={10}>
              <Form.Item label="快速添加" labelCol={{ span: 6 }}>
                <Input
                  disabled={disabled}
                  autoFocus
                  allowClear
                  placeholder="扫描商品条形码，快速添加"
                  value={state.code}
                  onPressEnter={async (e) => {
                    await action.getGoods({
                      id: e.currentTarget.value,
                      dispatch,
                      state,
                    });
                    dispatch({ type: "InputCode", payload: "" });
                  }}
                  onChange={(e) => {
                    dispatch({ type: "InputCode", payload: e.target.value });
                  }}
                />
              </Form.Item>
            </Col>
          </Row> */}
       
        </div>

        <div style={{ marginTop: -20 }}>
          <ButtonPanel>
            <Button disabled={disabled} onClick={() => goodsFunc.setTrue()}>
              选择商品
            </Button>
            {/* <Button onClick={() => goodsFunc.setTrue()}>批量删除</Button> */}
          </ButtonPanel>
        </div>

        <DataTable dataList={state.tableList} disabled={disabled} />
        <TableExpand>
          合计库存数量：{count("number").toFixed(3)}
          <span style={{ marginLeft: 10 }}>
            合计变更差额：￥{count("diffPrice").toFixed(2)}
          </span>
        </TableExpand>
      </div>

      <ChooseShop
        visibleModal={shopState}
        close={(status, r) => {
          if (r) {
            action.setFormData({ dispatch, key: "shop", value: r[0] });
          }
          updateFormField("shopName");
          shopFunc.setFalse();
        }}
      />
      <ChooseGoods
        visibleModal={goodsState}
        rowKey="storageBatchNumber"
        close={(status, r) => {
          if (r) {
            console.log(r)
            action.addTableItem({ dispatch, list: r });
          }
          goodsFunc.setFalse();
        }}
        filter={{ zeroInventory: true }}
      />
    </div>
  );
}
